import { Dispatch, SetStateAction } from "react";
import { DocType } from "../types";
import { DropZone } from "shared/components/DropZone";
import { IconButton, IconButtonSize } from "shared/components/IconButton";
import { Cancel01Icon } from "@hugeicons-pro/core-stroke-rounded";
import { verificationSourceType } from "../../../utils";

export const DropZoneView = ({
  companyName,
  applicantFullName,
  files,
  setFiles,
  docType,
  months,
  onClose
}: {
  companyName?: string;
  applicantFullName: string;
  files: File[];
  setFiles: Dispatch<SetStateAction<File[]>>;
  docType: DocType;
  months: number;
  onClose?: () => void;
}) => {
  const monthsLabel = `most recent ${months} month${months === 1 ? "" : "s"}`;
  const docTypeLabel = verificationSourceType[docType] || docType;
  // A benefit letter is analyzed on its own, so the API accepts exactly one per re-verification.
  const isBenefitsLetter = docType === DocType.BenefitsStatement;

  return (
    <div className="flex flex-col h-full">
      <header className="p-6 border-b border-alpha-100">
        <h1 className="text-xl text-content-1000 font-bold mb-1 relative">
          Upload {docTypeLabel}
          <IconButton
            HugeIcon={Cancel01Icon}
            size={IconButtonSize.SM}
            borderLess
            className="absolute -top-2 -right-2"
            onClick={onClose}
          />
        </h1>

        <p className="text-sm font-medium text-content-400">
          {isBenefitsLetter ? (
            <>
              Upload one government benefit letter showing {applicantFullName}
              &apos;s current benefits
            </>
          ) : (
            <>
              Upload documents showing {applicantFullName}&apos;s income from
              {companyName ? `"${companyName}"` : "the current company"} for the{" "}
              {monthsLabel}
            </>
          )}
        </p>
      </header>
      <div className="flex-grow min-h-0 bg-background-900 p-6 h-full space-y-3 max-h-[488px] overflow-y-auto">
        <DropZone
          id="files"
          setValue={setFiles}
          value={files}
          title={`Upload ${docTypeLabel}`}
          subText={
            isBenefitsLetter ? "One letter only" : `for the ${monthsLabel}`
          }
        />
      </div>
    </div>
  );
};
